import { render } from "./Spinner.vue?vue&type=template&id=39432f99&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=39432f99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39432f99"],['__file',"src/components/Spinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39432f99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39432f99', __exports__)) {
    api.reload('39432f99', __exports__)
  }
  
  module.hot.accept("./Spinner.vue?vue&type=template&id=39432f99&scoped=true", () => {
    api.rerender('39432f99', render)
  })

}


export default __exports__